const { Link, useParams } = require("react-router-dom")

export const TopicListItem = ({topic})=>{
    const { school } = useParams();

    return (
        <li className={`${topic.completeYn === 'N' ? 'progress':''} ${topic.deleteYn === 'Y' ? 'deleted':''}`}>
        <Link to={`/${school}/donghwa/${topic.id}`}>
            <div className="brief">
                <div className="term">
                    <span className={`label_donghwa ${topic.completeYn === "N" && "progress"}`}>{topic.completeYn === "N" ? "진행중" : "완료"}</span>
                    <p>{topic.stdate}~{topic.eddate}</p>
                </div>
                <h2 className="title">{topic.title}</h2>
                <h2 className="sub_title cover">{topic.subTitle}</h2>
                <p className="desc cover">{topic.content}</p>
            </div>
            <div className="etc">
                <p className="txt">훈장님<span>{topic.teacherUser.name} 작가님</span></p>
                <p className="txt">참여 어린이<span>{topic.storyCount} 명</span></p>
            </div>
        </Link>
        </li>
    )
}